// extracted by mini-css-extract-plugin
export default {"button":"CloseIconButton_button__dFl6T"};